export default "__VITE_ASSET__DMcVPVVx__"